import EntityModel from '@/common/models/entity-model';
import EmailAttachmentModel from '@/common/models/email-attachment-model';

export default class EmailMessageModel extends EntityModel {
    static Statuses = {
        draft: 'draft',
        outbox: 'outbox',
        sending: 'sending',
        sent: 'sent',
        failed: 'failed',
    };

    hydrate({
        from = null,
        to = null,
        cc = [],
        bcc = [],
        subject = null,
        text = '',
        html = '',
        attachments = [],
        metadata = {},
        credentialHash = null,
    } = {}) {
        this.from = from;
        this.to = to;
        this.cc = cc;
        this.bcc = bcc;
        this.subject = subject;
        this.text = text;
        this.html = html;
        this.attachments = attachments.map(v => new EmailAttachmentModel(v));
        this.metadata = metadata;
        this.credentialHash = credentialHash;
    }

    addAttachments(attachments) {
        this.attachments = attachments.map(v => new EmailAttachmentModel(v));
    }

    get hasAttachments() {
        return this.attachments.length > 0;
    }

    getPayload() {
        let payload = {
            from: this.from,
            to: this.to,
            cc: this.cc,
            bcc: this.bcc,
            subject: this.subject,
            text: this.text || '',
            html: this.html || '',
            attachments: this.attachments.map(v => v.getPayload()) || [],
            metadata: this.metadata || {},
        };

        if (this.credentialHash) {
            payload = {
                ...payload,
                credentialHash: this.credentialHash,
            };
        }
        return payload;
    }
}
